export const industryMap = {
  'Transport, Postal and Warehousing': {
    'Road Transport': ['Road Freight Transport', 'Road Passenger Transport'],
    'Rail Transport': ['Rail Freight Transport', 'Rail Passenger Transport'],
    'Water Transport': ['Water Freight Transport', 'Water Passenger Transport'],
    'Air and Space Transport': ['Air and Space Transport'],
    'Other Transport': [
      'Scenic and Sightseeing Transport',
      'Pipeline and Other Transport',
    ],
    'Postal and Courier Pick-Up and Delivery Services': [
      'Postal and Courier Pick-Up and Delivery Services',
    ],
    'Transport Support Services': [
      'Water Transport Support Services',
      'Airport Operations and Other Air Transport Support Services',
      'Other Transport Support Services',
    ],
    'Warehousing and Storage Services': ['Warehousing and Storage Services'],
  },
  Mining: {
    'Coal Mining': ['Coal Mining'],
    'Oil and Gas Extraction': ['Oil and Gas Extraction'],
    'Metal ore Mining': ['Metal ore Mining'],
    'Non-Metallic Mineral Mining and Quarrying': [
      'Construction Material Mining',
      'Other Non-Metallic Mineral Mining and Quarrying',
    ],
  },
  'Exploration and Other Mining Support Services': {
    Exploration: ['Petroleum Exploration', 'Mineral Exploration'],
    'Other Mining Support Services': ['Other Mining Support Services'],
  },
  Construction: {
    'Building Construction': [
      'Residential Building Construction',
      'Non-Residential Building Construction',
    ],
    'Heavy and Civil Engineering Construction': [
      'Heavy and Civil Engineering Construction',
    ],
    'Construction Services': [
      'Land Development and Site Preparation Services',
      'Building Structure Services',
      'Building Installation Services',
      'Building Completion Services',
      'Other Construction Services',
    ],
  },
  'Agriculture, Forestry and Fishing': {
    Agriculture: [
      'Nursery and Floriculture Production',
      'Mushroom and Vegetable growing',
      'Fruit and Tree Nut Growing',
      'Sheep, Beef and Grain Farming',
      'Other Crop Growing',
      'Dairy Cattle Farming',
      'Poultry Farming',
      'Deer Farming',
      'Other Livestock Farming',
    ],
    Aquaculture: ['Aquaculture'],
    'Forestry and Logging': ['Forestry and Logging'],
    'Fishing, Hunting and Trapping': ['Fishing', 'Hunting and Trapping'],
    'Agriculture, Forestry and Fishing Support Services': [
      'Agriculture, Forestry and Fishing Support Services',
    ],
  },
  'Electricity, Gas, Water and Waste Services': {
    'Electricity Supply': [
      'Electricity Generation',
      'Electricity Transmission',
      'Electricity Distribution',
      'On Selling Electricity and Electricity Market Operation',
    ],
    'Gas Supply': ['Gas Supply'],
    'Water Supply, Sewerage and Drainage Services': [
      'Water Supply, Sewerage and Drainage Services',
    ],
    'Waste Collection, Treatment and Disposal Services': [
      'Waste Collection Services',
      'Waste Treatment, Disposal and Remediation Services',
    ],
  },
  Manufacturing: {
    'Food Product Manufacturing': [
      'Meat and Meat Product Manufacturing',
      'Seafood Processing',
      'Dairy Product Manufacturing',
      'Fruit and Vegetable Processing',
      'Oil and Fat Manufacturing',
      'Grain Mill and Cereal Product Manufacturing',
      'Bakery Product Manufacturing',
      'Sugar and Confectionery Manufacturing',
      'Other Food Product Manufacturing',
    ],
    'Beverage and Tobacco Product Manufacturing': [
      'Beverage Manufacturing',
      'Cigarette and Tobacco Product Manufacturing',
    ],
    'Textile, Leather, Clothing and Footwear Manufacturing': [
      'Textile Manufacturing',
      'Leather Tanning, Fur Dressing and Leather Product Manufacturing',
      'Textile Product Manufacturing',
      'Knitted Product Manufacturing',
      'Clothing and Footwear Manufacturing',
    ],
    'Wood Product Manufacturing': [
      'Log Sawmilling and Timber Dressing',
      'Other Wood Product Manufacturing',
    ],
    'Pulp, Paper and Converted Paper Product Manufacturing': [
      'Pulp, Paper and Paperboard Manufacturing',
      'Converted Paper Product Manufacturing',
    ],
    'Printing (including the Reproduction of Recorded Media)': [
      'Printing and Printing Support Services',
      'Reproduction of Recorded Media',
    ],
    'Petroleum and Coal Product Manufacturing': [
      'Petroleum and Coal Product Manufacturing',
    ],
    'Basic Chemical and Chemical Product Manufacturing': [
      'Basic Chemical Manufacturing',
      'Basic Polymer Manufacturing',
      'Fertiliser and Pesticide Manufacturing',
      'Pharmaceutical and Medicinal Product Manufacturing',
      'Cleaning Compound and Toiletry Preparation Manufacturing',
      'Other Basic Chemical Product Manufacturing',
    ],
    'Polymer Product and Rubber Product Manufacturing': [
      'Polymer Product Manufacturing',
      'Natural Rubber Product Manufacturing',
    ],
    'Non-Metallic Mineral Product Manufacturing': [
      'Glass and Glass Product Manufacturing',
      'Ceramic Product Manufacturing',
      'Cement, Lime, Plaster and Concrete Product Manufacturing',
      'Other Non-Metallic Mineral Product Manufacturing',
    ],
    'Primary Metal and Metal Product Manufacturing': [
      'Basic Ferrous Metal Manufacturing',
      'Basic Ferrous Metal Product Manufacturing',
      'Basic Non-Ferrous Metal Manufacturing',
      'Basic Non-Ferrous Metal Product Manufacturing',
    ],
    'Fabricated Metal Product Manufacturing': [
      'Iron and Steel Forging',
      'Structural Metal Product Manufacturing',
      'Metal Container Manufacturing',
      'Sheet Metal Product Manufacturing (except Metal Structural and Container Products)',
      'Other Fabricated Metal Product Manufacturing',
    ],
    'Transport Equipment Manufacturing': [
      'Motor Vehicle and Motor Vehicle Part Manufacturing',
      'Other Transport Equipment Manufacturing',
    ],
    'Machinery and Equipment Manufacturing': [
      'Professional and Scientific Equipment Manufacturing',
      'Computer and Electronic Equipment Manufacturing',
      'Electrical Equipment Manufacturing',
      'Domestic Appliance Manufacturing',
      'Pump, Compressor, Heating and Ventilation Equipment Manufacturing',
      'Specialised Machinery and Equipment Manufacturing',
      'Other Machinery and Equipment Manufacturing',
    ],
    'Furniture and Other Manufacturing': [
      'Furniture Manufacturing',
      'Other Manufacturing',
    ],
  },
  'Wholesale Trade': {
    'Basic Material Wholesaling': [
      'Agricultural Product Wholesaling',
      'Mineral, Metal and Chemical Wholesaling',
      'Timber and Hardware Goods Wholesaling',
    ],
    'Machinery and Equipment Wholesaling': [
      'Specialised Industrial Machinery and Equipment Wholesaling',
      'Other Machinery and Equipment Wholesaling',
    ],
    'Motor Vehicle and Motor Vehicle Parts Wholesaling': [
      'Motor Vehicle and Motor Vehicle Parts Wholesaling',
    ],
    'Grocery, Liquor and Tobacco Product Wholesaling': [
      'Grocery, Liquor and Tobacco Product Wholesaling',
    ],
    'Other Goods Wholesaling': [
      'Textile, Clothing and Footwear Wholesaling',
      'Pharmaceutical and Toiletry Goods Wholesaling',
      'Furniture, Floor Covering and Other Goods Wholesaling',
    ],
    'Commission-Based Wholesaling': ['Commission-Based Wholesaling'],
  },
  'Retail Trade': {
    'Motor Vehicle and Motor Vehicle Parts Retailing': [
      'Motor Vehicle Retailing',
      'Motor Vehicle Parts and Tyre Retailing',
    ],
    'Fuel Retailing': ['Fuel Retailing'],
    'Food Retailing': [
      'Supermarket and Grocery Stores',
      'Specialised Food Retailing',
    ],
    'Other Store-Based Retailing': [
      'Furniture, Floor Coverings, Houseware and Textile Goods Retailing',
      'Electrical and Electronic Goods Retailing',
      'Hardware, Building and Garden Supplies Retailing',
      'Recreational Goods Retailing',
      'Clothing, Footwear and Personal Accessory Retailing',
      'Department Stores',
      'Pharmaceutical and Other Store-Based Retailing',
    ],
    'Non-Store Retailing and Retail Commission-Based Buying and/or Selling': [
      'Non-Store Retailing',
      'Retail Commission-Based Buying and/or Selling',
    ],
  },
  'Accommodation and Food Services': {
    Accommodation: ['Accommodation'],
    'Food and Beverage Services': [
      'Cafes, Restaurants and Takeaway Food Services',
      'Pubs, Taverns and Bars',
      'Clubs (Hospitality)',
    ],
  },
  'Information Media and Telecommunications': {
    'Publishing (except Internet and Music Publishing)': [
      'Newspaper, Periodical, Book and Directory Publishing',
      'Software Publishing',
    ],
    'Motion Picture and Sound Recording Activities': [
      'Motion Picture and Video Activities',
      'Sound Recording and Music Publishing',
    ],
    'Broadcasting (except Internet)': [
      'Radio Broadcasting',
      'Television Broadcasting',
    ],
    'Internet Publishing and Broadcasting': [
      'Internet Publishing and Broadcasting',
    ],
    'Telecommunications Services': ['Telecommunications Services'],
    'Internet Service Providers, Web Search Portals and Data Processing Services':
      ['Internet Service Providers and Web Search Portals'],
    'Library and Other Information Services': [
      'Libraries and Archives',
      'Other Information Services',
    ],
  },
  'Financial and Insurance Services': {
    Finance: [
      'Central Banking',
      'Depository Financial Intermediation',
      'Non-Depository Financing',
      'Financial Asset Investing',
    ],
    'Insurance and Superannuation Funds': [
      'Life Insurance',
      'Health and General Insurance',
      'Superannuation Funds',
    ],
    'Auxiliary Finance and Insurance Services': [
      'Auxiliary Finance and Investment Services',
      'Auxiliary Insurance Services',
    ],
  },
  'Rental, Hiring and Real Estate Services': {
    'Rental and Hiring Services (except Real Estate)': [
      'Motor Vehicle and Transport Equipment Rental and Hiring',
      'Farm Animal and Bloodstock Leasing',
      'Other Goods and Equipment Rental and Hiring',
      'Non-Financial Intangible Assets (Except Copyrights) Leasing',
    ],
    'Property Operators and Real Estate Services': [
      'Property Operators',
      'Real Estate Services',
    ],
  },
  'Professional, Scientific and Technical Services': {
    'Professional, Scientific and Technical Services': // (Except Computer System Design and Related Services)':
      [
        'Scientific Research Services',
        'Architectural, Engineering and Technical Services',
        'Legal and Accounting Services',
        'Advertising Services',
        'Market Research and Statistical Services',
        'Management and Related Consulting Services',
        'Veterinary Services',
        'Other Professional, Scientific and Technical Services',
      ],
    'Computer System Design and Related Services': [
      'Computer System Design and Related Services',
    ],
  },
  'Administrative and Support Services': {
    'Administrative Services': [
      'Employment Services',
      'Travel Agency and Tour Arrangement Services',
      'Other Administrative Services',
    ],
    'Building Cleaning, Pest Control and Other Support Services': [
      'Building Cleaning, Pest Control and Gardening Services',
      'Packaging Services',
    ],
  },
  'Public Administration and Safety': {
    'Public Administration': [
      'Central Government Administration',
      'State Government Administration',
      'Local Government Administration',
      'Justice',
      'Government Representation',
    ],
    Defence: ['Defence'],
    'Public Order, Safety and Regulatory Services': [
      'Public Order and Safety Services',
      'Regulatory Services',
    ],
  },
  'Education and Training': {
    'Preschool and School Education': [
      'Preschool Education',
      'School Education',
    ],
    'Tertiary Education': ['Tertiary Education'],
    'Adult, Community and Other Education': [
      'Adult, Community and Other Education',
      'Educational Support Services',
    ],
  },
  'Health Care and Social Assistance': {
    Hospitals: ['Hospitals'],
    'Medical and Other Health Care Services': [
      'Medical Services',
      'Pathology and Diagnostic Imaging Services',
      'Allied Health Services',
      'Other Health Care Services',
    ],
    'Residential Care Services': ['Residential Care Services'],
    'Social Assistance Services': [
      'Child Care Services',
      'Other Social Assistance Services',
    ],
  },
  'Arts and Recreation Services': {
    'Heritage Activities': ['Museum Operation', 'Parks and Gardens Operations'],
    'Creative and Performing Arts Activities': [
      'Creative and Performing Arts Activities',
    ],
    'Sports and Recreation Activities': [
      'Sports and Physical Recreation Activities',
      'Horse and Dog Racing Activities',
      'Amusement and Other Recreation Activities',
    ],
    'Gambling Activities': ['Gambling Activities'],
  },
  'Other Services': {
    'Repair and Maintenance': [
      'Automotive Repair and Maintenance',
      'Machinery and Equipment Repair and Maintenance',
      'Other Repair and Maintenance',
    ],
    'Personal and Other Services': [
      'Personal Care Services',
      'Funeral, Crematorium and Cemetery Services',
      'Other Personal Services',
      'Religious Services',
      'Civic, Professional and Other Interest Group Services',
    ],
    'Private Households Employing Staff and Undifferentiated Goods': //- and Service-Producing Activities of Households for Own Use':
      [
        'Private Households Employing Staff and Undifferentiated Goods- and Service-Producing Activities of Households for Own Use',
      ],
    'Other Services': ['Other Services'],
  },
};
